import React, { useState, useEffect } from 'react';
import { ReactComponent as Arrow } from "../../../assets/svg/arrow.svg";
import styles from "./DetailsInfo.module.scss";
import { motion } from "framer-motion";
import ButtonsProject from "../../UI/ButtonsProject/ButtonsProject";
import SubQuotationPostulation from "../../MarketPlace/subCotizacion/subCotizacionPostulante/SubQuotationPostulation";
import SubProjectBudgets from './SubProjectBudgets';
import { connect } from 'react-redux';
import { getProjectBudgets, getSubProjectBudgets } from '../../../store/actions';


const DetailsInfo = ({
  isPostulation,
  isProject,
  allowOpen,
  dropdownOpen,
  setDropdownOpen,
  isPostulationAllowed,
  getProjectBudgets,
  projectBudgets,
  getSubProjectBudgets,
  count,
  fromPage,
  name,
  zone,
  startDate,
  endDate,
  description,
  displayInfo,
  item,
  isPostulating,
  subProjectBudgets,
  status,
  onClick,
  id,
  type,
  mainProject,
  userData,
  isAllowed,
  ...props
}) => {
  const [budgetToPass, setBudgetToPass] = useState([]);

  const showRecivedBudgets = mainProject.user.id === userData.id
   
  return (
    <>
      <div>
          <div
            className={`${dropdownOpen ? styles.opened : ""} ${
              styles.itemInfo
            }`}
          >
            <p className={styles.rubro}>{`${count}. ${
              name || 'No hay titulo'
            }`}</p>
          </div>

          <motion.div
            initial={{ height: "0px", opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            className={styles.itemInfo_container}
          >
            <div className={`${styles.itemInfo_container_subProject} ${dropdownOpen ? styles.opened : ""}`}>
                <div className={styles.subDescription}>
                  {description === "undefined" || description === undefined || description === null || description === "" ? "No hay descripción" : description}
                </div>  

              {type === "subquotation" && props.userId === props.userData.id ? (
                <SubQuotationPostulation id={id} item={item} />
              ) : (
                <span className={styles.buttonsProject}>
                  <ButtonsProject
                    subproyecto={item}
                    type={type}
                    onClick={onClick}
                    isPostulating={isPostulating || status === "SEND"}
                    isAllowed={isPostulationAllowed?.status}
                    mainProjectId={mainProject.id}
                    mainProject={mainProject}
                  />
                </span>
              )}             
            </div>
            {showRecivedBudgets && 
                <div className={styles.subBudgets}>
                  <div className={styles.subBudgets_title}>Presupuestos recibidos</div>
                  <SubProjectBudgets subproject={item} mainProject={mainProject} subProjectBudgets={subProjectBudgets}/>
                </div>
            }
          </motion.div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    projectBudgets: state.profile.projectBudgets,

  };
}

export default connect(mapStateToProps,{ getProjectBudgets, getSubProjectBudgets })(DetailsInfo);
